import {GameBase} from "./GameBase";
import {PunchDetector} from "../detector/PunchDetector";
import {SoundEffect} from "../common/SoundEffect";
import {Point} from "../Point";
import {RecordManager} from "../common/RecordManager";

export class Seiken extends GameBase {
  constructor() {
    super()
    this.score = 0
    const onInit = () => {
      this.se2.play()
      switch (this.fistType) {
        case 'each':
          this.right = !this.right
          break
        case 'right':
          this.right = true
          break
        case 'left':
          this.left = false
          break
      }
    }
    const onDetect = () => {
      this.se1.play()
      this.score++
      this.saveData()
    }
    this.punchDetector = new PunchDetector(onInit, onDetect)
    this.initSound()

    this.fistType = null;
    this.right = true
  }

  changeSettings(key, value) {
    super.changeSettings(key, value)
    switch (this.fistType) {
      case 'right':
        this.right = true
        break
      case 'left':
        this.left = false
        break
    }
    this.punchDetector[key] = value
  }

  initSound() {
    this.se1 = new SoundEffect("don")
    this.se2 = new SoundEffect("kaka")
  }

  mainLoop({ pose, hands }) {
    if (!pose || !pose[0]) return

    const points2D = pose[0].keypoints
    const points = pose[0].keypoints3D
    this.navigations = []
    if (this.right && points2D[20].score < 0.7) {
      this.navigations.push({icon: 'warning', text: "右手が映る位置"})
      return
    }
    if (!this.right && points2D[19].score < 0.7) {
      this.navigations.push({icon: 'warning', text: "左手が映る位置"})
      return
    }
    // this.debug = this.punchDetector.avg.toString().substr(0,4)

    if (this.right) {
      this.punchDetector.mainLoop(new Point(points[20]), new Point(points[12]))
    } else {
      this.punchDetector.mainLoop(new Point(points[19]), new Point(points[11]))
    }
  }

  saveData() {
    RecordManager.getInstance().addRecords('seiken', {
      'time': 2,
      'continuousCount': 1,
      'count': 1,
    })
  }

  renderCamera(ctx, { pose, hands }) {

    // const shoulder = new Point(points[12])
    // const fist = new Point(points[20])
    //
    // const r = Math.atan2(points[12].z, points[12].x) * 180 / Math.PI + 180;
    // const r2 = (r + 90 % 360) * Math.PI / 180;
    // const dist = Point.dist3D(points[12], Point.getOrigin())
    // const vec = new Point({ x: dist * -Math.cos(r2), y: 0, z: dist * Math.sin(r2) })
    //
    // const factorTo2D = 500
    // const target = new Point(points2D[12]).add(vec.multiply(factorTo2D))
    // this.ctx = ctx
    // this.ctx.fillStyle = 'red'
    // this.drawCircle({x:target.x,y:target.y}, Math.max(0, target.z * 0.5))
    //
    // const dist2 = Point.distXZ(fist, Point.getOrigin())

  }

  drawCircle(pos, size) {
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2, true);
    this.ctx.stroke();
    this.ctx.fill();
  }
}



// WEBPACK FOOTER //
// ./src/components/game/Seiken.js